import React from "react";
import { PARTY_SCOPE } from "../apiContract";
import CreditNoteListSection from "../components/CreditNoteListSection";

export default function BuyerCreditNotesPage() {
  return (
    <div className="container py-3">
      <h2 className="fw-bold mb-4">My Credits</h2>
      <CreditNoteListSection
        partyScope={PARTY_SCOPE.DIRECT_BUYER}
        detailLinkPrefix="/credit-notes"
      />
    </div>
  );
}
